import api from "apiSingleton";

import { useTheme } from "styled-components";
import { useState, useCallback, useImperativeHandle, forwardRef } from "react";

import Select from "components/ui-kit/Select";
import { TextInput } from "components/ui-kit/inputs/TextInput";

import { Title } from "../styles";

import ModalLayout from "../../ModalLayout";

const initialState = {
  open: false,
  editable: false,
  group: undefined,
}

const SelectItemModal = forwardRef(({
  restaurant,
  addItem = () => { },
}, ref) => {

  const theme = useTheme();
  const [modal, setModal] = useState(initialState);

  const closeModal = useCallback(() => setModal(initialState), []);
  const editModalGroup = useCallback((event) => {
    setModal((modal) => ({
      ...modal,
      group: modal.editable ? event.target.value : modal.group,
    }));
  }, []);

  useImperativeHandle(ref, () => {
    return {
      open: (group) => setModal({
        open: true,
        editable: !group,
        group,
      }),
    }
  }, []);

  const loadOptions = useCallback(async (search) => {
    if (!restaurant) return;
    const response = await api.products.getList({
      short_projection: true,
      status: 1,
      search,
      restaurant,
    });
    return response.data?.map(({ id: value, title_ua: label }) => ({
      label,
      value
    }));
  }, [restaurant]);

  const selectItem = useCallback((value) => {
    setModal(({ group }) => {
      addItem(group, value);
      return initialState;
    });
  }, [addItem]);

  return (
    <ModalLayout theme={theme} modalIsOpen={modal.open} closeModal={closeModal}>
      <Title>Включити позицію</Title>
      <TextInput
        title="Назва групи"
        type="text"
        value={modal.group}
        disabled={!modal.editable}
        onChange={editModalGroup}
        isStyle
      />
      {!!modal.group && (
        <Select
          selectOptions={[]}
          loadOptions={loadOptions}
          valueKey="included_items"
          label="Пошук позиції"
          mode="primary"
          onChange={selectItem}
          isSearchable
          async
        />
      )}
    </ModalLayout>
  );
});

export default SelectItemModal;
